import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  Button,
  Input,
} from 'reactstrap';
import Select from 'react-select';

import {
  findingByIdSelector,
  findingIdSelector,
  resolutionOptionsSelector,
} from '../../../selectors/findingsSelectors';
import { resolveFinding } from '../../../redux/actions/Findings';

/*
Constants and helpers
*/

const DEFAULT_ROWS = 5;
const NOTE_MAX_LENGTH = 500;
const NOTE_MIN_LENGTH = 0;

const DEFAULT_RESOLUTION_VALUE = 10;
const STATUS_RESOLVED = 40;

const FORM_TITLE_NOT_RESOLVED = 'Resolve the Finding';
const FORM_TITLE_RESOLVED = 'Edit the Resolution';

const SAVE_BTN_TITLE_NOT_RESOLVED = 'Save';
const SAVE_BTN_TITLE_RESOLVED = 'Update';

const isResolved = findingStatus =>
  findingStatus === STATUS_RESOLVED;

export const getFormTitle = findingStatus => isResolved(findingStatus)
  ? FORM_TITLE_RESOLVED
  : FORM_TITLE_NOT_RESOLVED;

const getBtnTitle = findingStatus => isResolved(findingStatus)
  ? SAVE_BTN_TITLE_RESOLVED
  : SAVE_BTN_TITLE_NOT_RESOLVED;
/*
Helpers
*/

const getOption = ({
  options,
  optionValue,
}) =>
  optionValue
    ? options
      .find(option => option.value === optionValue)
    : options
      .find(option => option.value === DEFAULT_RESOLUTION_VALUE);

/*
Component
*/

const FindingResolution = (props) => {
  const {
    dispatchResolveFinding,
    findingId,
    findingStatus,
    resolution: resolutionExisting,
    resolutionNotes: resolutionNotesExisting,
    resolutionOptions,
  } = props;

  const [btnTitle, setBtnTitle] = useState(SAVE_BTN_TITLE_RESOLVED);
  const [resolutionType, setResolutionType] = useState(resolutionExisting);
  const [resolutionNotes, setResolutionNotes] =
    useState(resolutionNotesExisting);

  useEffect(() => {
    setBtnTitle(getBtnTitle(findingStatus));
  }, [findingStatus]);

  useEffect(() => {
    const option = getOption({
      options: resolutionOptions,
      optionValue: resolutionExisting,
    });

    setResolutionType(option);
  }, [resolutionExisting, resolutionOptions]);

  useEffect(() => {
    setResolutionNotes(resolutionNotesExisting);
  }, [resolutionNotesExisting]);

  const handleChangeResolutionType = (selectedOption) => {
    setResolutionType(selectedOption);
  };

  const handleChangeNotes = (evt) => {
    setResolutionNotes(evt.target.value);
  };

  const handleSave = () => {
    const {
      value: resolution = DEFAULT_RESOLUTION_VALUE,
    } = resolutionType;

    const data = {
      status: 40,
      resolution,
      resolutionNotes,
    };

    dispatchResolveFinding({
      findingId,
      data,
    });
  };

  return (
    <div className="support-form-container">
      <div className="support-form-item">
        <div className="support-item-name">
          Resolve as
        </div>

        <Select
          className="support-form-select"
          onChange={handleChangeResolutionType}
          options={resolutionOptions}
          value={resolutionType}
        />

      </div>

      <div className="support-form-item">
        <div className="support-item-name">
          Resolution notes
        </div>

        <Input
          type="textarea"
          className="blocking-form-textarea"
          rows={DEFAULT_ROWS}
          maxLength={NOTE_MAX_LENGTH}
          minLength={NOTE_MIN_LENGTH}
          onChange={handleChangeNotes}
          value={resolutionNotes}
        />
      </div>

      <div className="support-form-footer">
        <Button
          className="support-form-submit-btn"
          type="submit"
          color="primary"
          onClick={handleSave}
        >
          {btnTitle}
        </Button>
      </div>
    </div>
  );
};

FindingResolution.propTypes = {
  dispatchResolveFinding: PropTypes.func.isRequired,
  findingId: PropTypes.string.isRequired,
  findingStatus: PropTypes.number.isRequired,
  resolution: PropTypes.number.isRequired,
  resolutionNotes: PropTypes.string.isRequired,
  resolutionOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = (state) => {
  const findingId = findingIdSelector(state);

  const finding = findingByIdSelector(state);
  const {
    status: findingStatus,
    resolution = DEFAULT_RESOLUTION_VALUE,
    resolutionNotes = '',
  } = finding;

  const resolutionOptions = resolutionOptionsSelector(state);

  return {
    findingId,
    findingStatus,
    resolution,
    resolutionNotes,
    resolutionOptions,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatchResolveFinding: ({ findingId, data }) => {
    dispatch(resolveFinding({ findingId, data }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FindingResolution);
